import type { InputHTMLAttributes, Ref } from "react";
import { cn } from "@/shared/lib/cn";

export function Input({
  className,
  ref,
  ...props
}: InputHTMLAttributes<HTMLInputElement> & { ref?: Ref<HTMLInputElement> }) {
  return (
    <input
      ref={ref}
      className={cn(
        "h-9 w-full rounded-lg border border-border bg-surface px-3 text-sm text-fg transition-all duration-150 placeholder:text-muted focus:border-primary focus:bg-surface focus:ring-2 focus:ring-primary/20 focus:outline-none shadow-2xs",
        className,
      )}
      {...props}
    />
  );
}
